/* eslint-disable @next/next/no-img-element */
'use client';

import { c as _c } from "react/compiler-runtime";
import { sortNftAtom } from "@/config/atoms/sortNftAtom";
import type { NftPoolConfig, NftPoolConfigType } from "@/constants/types";
import { IfNull } from '@/util/logic';
import { nftSort } from "@/util/nft/sort";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { useAtom } from "jotai";
import { useEffect } from "react";
const TWEEN_FACTOR_BASE = 0.4;
const numberWithinRange = (number: number, min: number, max: number): number => Math.min(Math.max(number, min), max);
interface NftCarouselProps {
  nfts: number[];
  currentPool: NftPoolConfigType | NftPoolConfig | undefined;
  selectable?: boolean;
  targetKey: string;
  sortBy?: "Ascending" | "Descending";
  onSelect?: (nft: string) => void;
}
export function NftCarousel(t0) {
  const $ = _c(24);
  const {
    nfts,
    currentPool,
    targetKey
  } = t0;
  const [sort] = useAtom(sortNftAtom);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: true,
      dragFree: true
    };
    t2 = [Autoplay()];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const [emblaRef] = useEmblaCarousel(t1, t2);
  let t3;
  let t4;
  if ($[2] !== sort || $[3] !== targetKey) {
    t3 = () => {
      if (sort[targetKey] === "Ascending") {
        console.log("Ascending");
      } else {
        if (sort[targetKey] === "Descending") {
          console.log("Descending");
        }
      }
    };
    t4 = [sort, targetKey];
    $[2] = sort;
    $[3] = targetKey;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== currentPool?.nftExt || $[7] !== currentPool?.nftSymbol || $[8] !== currentPool?.nftUri || $[9] !== currentPool?.pid || $[10] !== nfts || $[11] !== sort || $[12] !== targetKey) {
    let t6;
    if ($[14] !== currentPool?.nftExt || $[15] !== currentPool?.nftSymbol || $[16] !== currentPool?.nftUri || $[17] !== currentPool?.pid) {
      t6 = (nft, i) => <div className="embla__slide" key={`${currentPool?.pid ?? 1}_${i}_div1`}><div className="embla__slide__number text-sm" key={`${currentPool?.pid ?? 1}_${i}_div2`}>{nft}</div><div className="w-full" key={`${currentPool?.pid ?? 1}_${i}_div3`}><img src={`${currentPool?.nftUri ?? "https://chewy.build/nft/pixelpalz/pixelpalz/"}${Number(nft).toString()}${currentPool?.nftExt ?? ".png"}`} className="embla__slide__img drop-shadow-md" key={`${currentPool?.pid ?? 1}_${i}_img`} alt={`${IfNull(currentPool?.nftSymbol, "NFT")} #${nft}`} /></div></div>;
      $[14] = currentPool?.nftExt;
      $[15] = currentPool?.nftSymbol;
      $[16] = currentPool?.nftUri;
      $[17] = currentPool?.pid;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t5 = nftSort(nfts, sort[targetKey]).map(t6);
    $[6] = currentPool?.nftExt;
    $[7] = currentPool?.nftSymbol;
    $[8] = currentPool?.nftUri;
    $[9] = currentPool?.pid;
    $[10] = nfts;
    $[11] = sort;
    $[12] = targetKey;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[19] !== t5) {
    t6 = <div className="embla__container">{t5}</div>;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== emblaRef || $[22] !== t6) {
    t7 = <div className="embla"><div className="embla__viewport" ref={emblaRef}>{t6}</div></div>;
    $[21] = emblaRef;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}